export default __webpack_public_path__ + "static/media/cluster_point_yellow.d58ecd7a.svg";